import React, { ReactNode } from 'react';

export interface StoreProviderProps<T> {
  children?: ReactNode;
  render?: (store: T) => ReactNode;
}

interface Props<T> extends StoreProviderProps<T> {
  store: T;
  context: React.Context<T>;
}

export const StoreProvider: <T>(props: Props<T>) => React.ReactElement<Props<T>> = ({
  store,
  context,
  render,
  children,
}) => {
  if (render) {
    return <context.Provider value={store}>{render(store)}</context.Provider>;
  }
  return <context.Provider value={store}>{children}</context.Provider>;
};



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/common/src/store/store-provider.component.tsx